import { ParsingCommentsDataBundlePropType } from "@interfaces/data-type/type.pages-comments";
import { Dispatch,FoxIcon,OwnIcon,StoragesSystem,  } from "index-module";
import React, { Component } from "react";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { HeaderGlobal } from "@module-layout/header/index.header.global";
import { FooterGlobal } from "@module-layout/footer/index.footer.global";
import { MyApps } from "./module/MyApps";
import { MyAppsSlider } from "./module/MyAppsSlider";
import { OwnImage } from "@img/module-images";


export interface ScreenHomePropTypeSmall {
  StoragesSystem: any,
  setStorage?: (obj: ParsingCommentsDataBundlePropType) => void
}

export type ScreenHomePropType = ScreenHomePropTypeSmall & RouteComponentProps;


const ScreenHomeDefaultProps : ScreenHomePropTypeSmall = {
  StoragesSystem: {
    catalog: [
    ]
  },
}

const MENU = [
  {id: '#apps_recent', className: "oneleft onehide-l", label: "Recents App"},
  {id: '#apps_apps', className: "oneleft onehide-l", label: "All Apps"},
  {id: '#contact', className: "oneleft onehide-l", label: "Contact"},
  {id: 'menu', className: "oneright menubtn", label: "", icon: "menu", isMenu: true},
  //{id: 'menu', className: "oneright onehide-l", label: "", icon: "search"},
  {id: 'ridwan', className: "oneright onehide-l", label: "", icon: "ridwan2", href: "/ridwan"},
  {id: 'foxdreem', className: "oneright onehide-l", label: "Foxdreem", icon: "foxdreem", href: "/"}
]


class ScreenApps extends Component<ScreenHomePropType,  any> {
  static defaultProps = ScreenHomeDefaultProps;
  constructor(props: any){
    super(props)
    this.state = {
      slider: [],
      apps: []
    }
  }

  logo = () => (
    <a href="/ridwan/store" className="title titleimg oneleft" hrefLang="en"><img src={OwnImage.FoxStoreIconWhite} />
      <label className="title ">
        <span style={{fontWeight: 'bold', color: '#fff'}}>fox</span>
        <span style={{fontWeight: 200}}>store</span>
        <span className="onetm">TM</span>
        </label>
    </a>
  )

  render(){
    const { props, state } = this;
    return(
      <>
        <HeaderGlobal topMenu = {MENU} logo = {this.logo} / >
          <section>
            <div className="onecol onebg-white" >
              <div className="slider ban" id="slider">
                <MyAppsSlider />
              </div>
            </div>

            {/* <!-- RECENT APP --> */}
            <div className="colomrecent">
              <div className="applist onecol fexbox foxapps" id="apps_recent">
                <div className="tittle">
                  <FoxIcon icon = {"ci"} className="oneicon one-ci onebg-purple onec-white oneleft" style={{padding: '10px', fontSize: '3em', borderRadius: '10px', display: 'inline-block', color: '#fff', marginRight: '20px'}}  />
                  <label className="oneleft" style={{padding: '15px 0 15px 0', fontSize: '1.2em', borderBottom: '2px solid #ccc'}}>RECENT APPS WE'VE DELIVER</label>
                </div>
                <MyApps  api = {"recent_apps"}/>
              </div>
              <div className="onec-blue" style={{fontSize: '1.2em', position: 'absolute', bottom: '-50px', left: 0, right: 0, textAlign: 'center'}}>
                We Create All Apps using Web Technologies
              </div>
            </div>


            {/* <!-- COLOM APPS --> */}
            <div className="colomapps" style={{paddingBottom: '40px'}}>
              <div className="applist onecol fexbox foxapps" id="apps_apps">
                <div className="tittle">
                  <FoxIcon icon = {"box"} className="oneicon one-box onebg-purple onec-white oneleft" style={{padding: '10px', fontSize: '3em', borderRadius: '10px', display: 'inline-block', color: '#fff', marginRight: '20px'}}  />
                  <label className="oneleft" style={{padding: '15px 0 15px 0', fontSize: '1.2em', borderBottom: '2px solid #ccc'}}>All WE HAVE FOR YOU</label>
                </div>
                <MyApps />
              </div>
            </div>

          </section>
        <FooterGlobal {...props}  />
      </>
    )
  }
}

const mapStateToProps = (state: any) => ({
  StoragesSystem: state.StoragesSystem,
})
const mapDispatchToProps = (dispatch: Dispatch ) => ({
  setStorage: ({ data, type }: ParsingCommentsDataBundlePropType) => dispatch( new StoragesSystem().setStorage({ data, type }) ),
})

export default withRouter(connect( mapStateToProps, mapDispatchToProps )( ScreenApps ));
